import { FileUrlBuilderOptions, buildFileUrl, parseFileAssetId } from '@sanity/asset-utils';

import { SanityReference } from 'types/studio/studio';

interface FileAssetType {
  _type: 'file';
  asset: SanityReference<any>;
}

export const getButtonFileLinkUrl = (file: FileAssetType) => {
  // eslint-disable-next-line no-underscore-dangle
  const fileRef = file?.asset?._ref;

  if (!fileRef) {
    return '';
  }

  const fileAsset = parseFileAssetId(fileRef);

  const asset: FileUrlBuilderOptions = {
    assetId: fileAsset?.assetId,
    projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || '',
    dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || '',
    extension: fileAsset.extension
  };

  return buildFileUrl(asset);
};
